import { useContext } from 'react';
import { propOr } from 'ramda';
import { useGetCurrencySymbol } from '@namespace/common';
import { useI18n } from '@namespace/i18n';
import { UserContext } from '@namespace/user';
import { normalizeFreeSpinBonusDetails } from '../../normalizers';
import { useBonusesStore } from '../../store';
import { useAllTypesBonuses } from '../allTypesBonuses';

const selectFreeSpinBonuses = () => propOr({}, 'freeSpinBonuses');
const selectFreeSpinBonusesHistory = () => propOr({}, 'freeSpinBonusesHistory');
const selectBonusDetails = () => propOr({}, 'bonusDetails');

export const useFreeSpinBonus = (bonusId) => {
  const getCurrencySymbol = useGetCurrencySymbol();
  const freeSpinBonuses = useBonusesStore(selectFreeSpinBonuses());
  const freeSpinBonusesHistory = useBonusesStore(
    selectFreeSpinBonusesHistory()
  );
  const bonusDetails = useBonusesStore(selectBonusDetails());
  const allTypesBonusesData = useAllTypesBonuses();
  const { data: bonusesData } = freeSpinBonuses;
  const { data: bonusesHistoryData } = freeSpinBonusesHistory;
  const { t, f } = useI18n();
  const [userData] = useContext(UserContext);

  const bonusData = bonusId
    ? {
        ...bonusesData,
        ...bonusesHistoryData,
        ...allTypesBonusesData // should be here for finding freespin bonus when all bonuses in single list
      }[bonusId]
    : bonusDetails;

  return normalizeFreeSpinBonusDetails({
    bonusData,
    userData,
    f,
    t,
    getCurrencySymbol
  });
};
